import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cardData: {},
  allPipelineData: [],
  action: null,
  upcomingTriggersDetails: [],
  allUpcomingRecentTriggerDetails: {},
  isOpen: false,
  roleName:"",
};

const wormholePipelineDashboardSlice = createSlice({
  name: 'wormholePipelineDashboardSlice',
  initialState,
  reducers: {
    setAllPipelineData: (state, action) => {
        state.allPipelineData = action.payload;
    },
    setDashboardCardData: (state, action) => {
        state.cardData = action.payload;
    },
    setUpcomingTriggersDetails: (state, action) => {
        state.upcomingTriggersDetails = action.payload;
    },
    setAction: (state, action) => {
        state.action = action.payload;
    },
    setAllUpcomingRecentTriggerDetails: (state, action) => {
        state.allUpcomingRecentTriggerDetails = action.payload;
    },
    openModal: (state) => {
      state.isOpen = true;
    },
    closeModal: (state) => {
      state.isOpen = false;
    },
    setRoleName: (state, action) => {
      state.roleName = action.payload;
    },
  },
});

export const { setAllPipelineData, setDashboardCardData, setUpcomingTriggersDetails, setAction, setAllUpcomingRecentTriggerDetails, openModal, closeModal,setRoleName } = wormholePipelineDashboardSlice.actions;

export default wormholePipelineDashboardSlice.reducer;
